import { Component, inject } from '@angular/core';
import { WorkSandbox } from '@app/work/sandboxes/work.sandbox';
import { SpotchecksScreen, SurveyService } from '@app/shared/services/survey.service';
import { ViewWillEnter } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';

@Component({
    templateUrl: './work.component.html',
    standalone: false
})
export class WorkComponent implements ViewWillEnter {
  protected readonly workSandbox = inject(WorkSandbox);
  private readonly surveyService = inject(SurveyService);

  ionViewWillEnter(): void {
    this.surveyService.trackScreen(SpotchecksScreen.MyWork);
    firstValueFrom(this.workSandbox.showWorkedHours$).then((showWorkedHours) => {
      if (showWorkedHours.showWorkedHoursLastWeek || showWorkedHours.showWorkedHoursPastWeeks) {
        this.workSandbox.getWorkHistory();
      }
    });
  }
}
